// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottomPosition[data-v-7f5696d0] {\n  bottom: 15px;\n}\n.paddingTop[data-v-7f5696d0] {\n  padding-top: 2px;\n}", ""]);
// Exports
module.exports = exports;
